export class PreAuthDto {
  countryCode: string;
  phone: string;
  idi: number;

  constructor(countryCode: string, phone: string, idi: number) {
    this.countryCode = countryCode;
    this.phone = phone;
    this.idi = idi;
  }
}